import { JSX, lazy, Suspense, useContext } from 'react';

import { QuillEditorProps } from './quill.types';
import { QuillInactiveContext } from './quill-inactive-context';

const QuillWrapped = lazy(() => import('./quill-wrapped'));

export default function Quill(props: QuillEditorProps): JSX.Element {
  // we want to short-circuit the quill editor from loading in a preview location, such as with campaigns
  // without a ton of special prop drilling or component swapping. Quill should be rendered in a preview mode
  // without loading anything if this is the case. This will not be defined by default and will in most circumstances
  // NOT be hidden
  const context = useContext(QuillInactiveContext);
  if (context.hidden) return <div dangerouslySetInnerHTML={{ __html: props.html }}></div>;

  return (
    <Suspense fallback="">
      <QuillWrapped {...props} />
    </Suspense>
  );
}
